// https://www.notion.so/MoonRush-API-Design-dd029c3ee4e84afe894d75a57c5a4e28?pvs=4#7ae51da4984349bb8924462c93ba6476
export enum RushGameStatus {
  INIT = 'INIT',
  PREPARING = 'PREPARING',
  ONGOING = 'ONGOING',
  NORMAL = 'NORMAL',
  RUSH = 'RUSH',
  END = 'END',
}

interface RushPlayer {
  name: string;
  uid: string;
  hiddenIdentity: 0 | 1;
}

export interface RushGameInfo {
  gameId: string;
  roundId: string;
  status: RushGameStatus;
  timestamp: string;
  restAward: string;
  totalGamePoint: string;
  currentUserPoint: string;
  currentGamePoint: string;
  rushPoint: string;
  grandPrize: string;
  betValues: string[];
  nextRoundIn?: string;
  winner?: RushPlayer | null;
  trigger?: RushPlayer | null;
}

export enum PrizeType {
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6,
  Seven = 7,
  Eight = 8,
  Nine = 9,
}

export interface Prize {
  id?: number;
  amount?: string;
  createdTime?: string;
  gameId?: string;
  rewardValue?: string;
  rewardAmount?: string;
  rewardComment?: string;
  payout?: string;
  multiplier?: number;
  probability?: string;
  // It's just a note, rewardType and rewardValue correspond one to one, and the front-end won't use rewardType.
  rewardType?: PrizeType;
  roundId?: string;
  text?: string;
  img?: string;
  openImg?: string;
  hash?: string;
  seed?: string;
  currency?: string;
  seedHash?: string;
}

interface User {
  id: string;
  name: string;
}

export interface Player {
  id: string;
  user: User | null;
}

export interface PushData {
  timer: number;
  grandPrizeAmount: number;
  majorPrizeAmount: number;
  miniPrizeAmount: number;
  playerList: Player[];
}

export interface RewardRecord {
  game: string;
  id: string;
  round: string;
  multiplier: string;
  rewardType: PrizeType;
  payout: string;
  rewardValue: PrizeType;
  amountType: number;
  amount: number;
  bettingAmount: number;
  createdTime: number;
  userName: string;
  userId: string;
  currency: string;
  uid?: string;
  point?: string;
}

export interface RushBetItem {
  betType: number;
  originalValue: number;
  betValue: number;
}

export interface RushGameData {
  event: {
    id: string;
    step: string; // WAIT, START, ONGOING, END
    rushId: string;
    timeline: string;
    round: string;
    ps: {
      id: string;
      round: string;
      timeline: string;
      ts: string;
    };
    ts: string;
  };
  gameId: string;
  roundId: string;
  status: RushGameStatus;
  restTime: string;
  timestamp: string;
  grandPrize: string;
  majorPrize: string;
  miniPrize: string;
  restAward: string;
  onTimeRecords: RewardRecord[];
  betValues: RushBetItem[];
  nextRoundIn: number;
}

export interface RushWsServerData {
  id: number;
  status: string; // "SUCCESS",
  data: RushGameData;
}

export interface OnlineUserRushBet {
  userId: string;
  userName: string;
  payoutMultiplier: string;
  rewardValue: PrizeType;
  rewardType: PrizeType;
  currency: string;
  payout: number;
  amount: string;
  multiplier: string;
  userPoint?: string;
}

export interface OnlineUserItem {
  bets: OnlineUserRushBet[];
  totalAmount: string;
  totalPlayers: string;
  anonymousPlayers: string;
}
